import axios from 'axios'
export default class UserService {
    static registerUser(username, password, email) {
        return new Promise((fulfill, reject) => {
            axios.post(`/users/users`, {
                username: username,
                password: password,
                email: email,
            }).then(response => {
                fulfill(response)
            }).catch(error=>{
                reject(error)
            })
        }).catch(error => {
            reject(error)
        })
    }
}